export default {
  title: 'Desconto de contrato anual',
  buttons: {
    edit: 'Editar desconto',
    save: 'Guardar desconto',
  },
  toasts: {
    invalid_discount: 'O desconto de contrato anual deve estar entre {{min}}% e {{max}}%',
  },
};
